/*
 * Public API Surface of catalean-version-controller
 */

export * from './lib/catalean-wishlist.module';
export * from './lib/catalean-wishlist.service';
export * from './lib/wishlist-presentation-header/wishlist-presentation-header.component';
